import { render, staticRenderFns } from "./MHPProfileFunctionCard.vue?vue&type=template&id=5775c6ba&scoped=true"
import script from "./MHPProfileFunctionCard.vue?vue&type=script&lang=js"
export * from "./MHPProfileFunctionCard.vue?vue&type=script&lang=js"
import style0 from "./MHPProfileFunctionCard.vue?vue&type=style&index=0&id=5775c6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5775c6ba",
  null
  
)

export default component.exports